module.exports = __webpack_public_path__ + "static/media/data-collection.b2ff1b12.jpg";